import { KeyValue } from "@/main/models/common";

export enum PartBrandTypes {
	GET_TIRE_BRAND = "@partBrand/GET_TIRE_BRAND",
	SAVE_TIRE_BRAND = "@partBrand/SAVE_TIRE_BRAND",
}

export interface PartBrandState {
	readonly tireBrand: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetTireBrand {
	type: typeof PartBrandTypes.GET_TIRE_BRAND;
	payload: { idBrandType: number };
}

export interface SaveTireBrand {
	type: typeof PartBrandTypes.SAVE_TIRE_BRAND;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export type PartBrandActionTypes = GetTireBrand | SaveTireBrand;
